<template>
  <div>
    <StartupListTopNav />
    <ScrollTopButton />
    <div class="mt-8 pane text-sm">
      <router-link :to="{ name: 'shortlistListPage' }"
        >All shortlists</router-link
      >
      <span class="text-gray-200 mx-2">/</span>
      <span>{{ shortlist.name }}</span>
    </div>
    <StartupList :shortlist-id="shortlistId" />
  </div>
</template>

<script>
import StartupList from 'modules/startup-list/StartupList.vue'
import StartupListTopNav from 'modules/startup-list/StartupListTopNav.vue'
import { useShortlists } from '@/states/shortlists/useShortlists'
import { computed } from '@vue/composition-api'

export default {
  components: {
    StartupList,
    StartupListTopNav,
  },
  props: {
    shortlistId: String,
  },
  setup(props) {
    const { shortlists, fetchShortlists } = useShortlists()
    fetchShortlists()
    const shortlist = computed(() => {
      return shortlists.value.filter((s) => s.id === props.shortlistId)[0] || {}
    })
    return {
      shortlist,
    }
  },
}
</script>
